import React from "react";
import visi from "../../../assets/img/tentang-kami/visi.png";
import misi from "../../../assets/img/tentang-kami/misi.png";
import Rive, {Layout} from "rive-react";
import bgRiv from "../../../assets/img/background/bg-black-animated.riv";

export default function VisiMisi() {

    return (
        <div className="container-visi-misi">
            <div className="grid-box">
                <img className="img-back" src={visi} alt='Visi'/>
                <div className="text-area">
                    <div className="rive-background">
                        <Rive
                            src={bgRiv}
                            layout={new Layout({fit: "cover", alignment: "center"})}
                            style={{width: "100%", height: "100%"}}
                        />
                    </div>
                    <div className="visi-misi-text">
                        <h2 className="text-header gradient-text pb-4">Visi Penyelenggara</h2>
                        <p>
                            Menjadi perusahaan layanan keuangan digital yang menjembatani kebutuhan
                            masyarakat melalui penerapan teknologi sebagai sarana layanan,
                            serta mendukung prinsip inklusi keuangan di Indonesia.
                        </p>
                    </div>
                </div>
            </div>
            <div className="grid-box right-grid">
                <img className="img-back" src={misi} alt='misi'/>
                <div className="text-area">
                    <div className="rive-background">
                        <Rive
                            src={bgRiv}
                            layout={new Layout({fit: "cover", alignment: "center"})}
                            style={{width: "100%", height: "100%"}}
                        />
                    </div>
                    <div className="visi-misi-text">
                        <h2 className="text-header gradient-text pb-4">Misi Penyelenggara</h2>
                        <p>
                            Kami menghadirkan layanan keuangan digital yang berlandaskan pada 5 (lima) prinsip utama:
                            <br/>
                            1. <i><strong>D</strong>eference</i> (Patuh) <br/>
                            2. <i><strong>A</strong>ssured</i> (Aman) <br/>
                            3. <i><strong>N</strong>imble</i> (Cepat Tanggap) <br/>
                            4. <strong>A</strong>plikatif <br/>
                            5. <strong>I</strong>ntuitif
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}